export const statusSignal = (infoScore) => {
  if (infoScore > 1) {
    return redSignal
  }

  if (infoScore <= 0) {
    return blueSignal
  }

  return normaLabelSignal
}

export const checkCpfStatus = (status) => {
  if (status === 'IRREGULAR') {
    return redSignal
  }

  if (status === 'REGULAR') {
    return blueSignal
  }
}

export const checkScore = (score) => {
  if (score < 150) {
    return redSignal
  }

  if (score >= 450) {
    return blueSignal
  }

  if (score >= 500) {
    return greenSignal
  }
}

export const checkProbability = (score) => {
  if (score < 50) {
    return greenSignal
  }

  if (score >= 10) {
    return blueSignal
  }

  if (score >= 80 && score <= 100) {
    return redSignal
  }
}

export const checkClass = (typeClass) => {
  if (typeClass === 'F' || typeClass === 'E') {
    return redSignal
  }

  if (typeClass === 'C' || typeClass === 'D') {
    return blueSignal
  }

  if (typeClass === 'A' || typeClass === 'B') {
    return greenSignal
  }
}

// Labels

export const statusLabelSignal = (infoScore) => {
  if (infoScore > 1) {
    return redSignal
  }
}

export const checkLabelCpfStatus = (status) => {
  if (status === 'IRREGULAR') {
    return redSignalFontBase
  }

  if (status === 'REGULAR') {
    return blueSignalFontBase
  }
}

export const checkLabelScore = (score) => {
  if (score < 150) {
    return redLabelSignal
  }

  if (score >= 450) {
    return blueLabelSignal
  }

  if (score >= 500) {
    return greenLabelSignal
  }
}

export const checkLabelProbability = (score) => {
  if (score < 50) {
    return greenLabelSignal
  }

  if (score >= 70) {
    return blueLabelSignal
  }

  if (score >= 80 && score <= 100) {
    return redLabelSignal
  }
}

export const checkLabelClass = (typeClass) => {
  if (typeClass === 'F' || typeClass === 'E') {
    return redLabelSignal
  }

  if (typeClass === 'C' || typeClass === 'D') {
    return blueLabelSignal
  }

  if (typeClass === 'A' || typeClass === 'B') {
    return greenLabelSignal
  }
}

const redSignalFontBase = {
  background: '#fff',
  color: 'red',
  fontSize: '12px',
}

const blueSignalFontBase = {
  background: '#fff',
  color: '#0F426F',
  fontSize: '12px',
}

const redSignal = {
  background: '#fff',
  color: 'red',
  border: '2px solid red',
}

const greenSignal = {
  background: '#fff',
  color: '#169F41',
  border: '2px solid #169F41',
}

const blueSignal = {
  background: '#fff',
  color: '#0F426F',
  border: '2px solid #0F426F',
}

const redLabelSignal = {
  color: 'red',
  background: '#fff',
}

const greenLabelSignal = {
  color: '#169F41',
  background: '#fff',
}

const blueLabelSignal = {
  color: '#0F426F',
  background: '#fff',
}

const normaLabelSignal = {
  color: '#D2D2D2',
}
